 <div class="loader-bg1">
        <style>
            .loader-bg1 {
                position: fixed;
                left: 0;
                top: 0;
                right: 0;
                bottom: 0;
                background-color: #f6f6f6f7;
                z-index: 99999;
                opacity: 1;
                display: flex;
                justify-content: center;
                align-items: center;
            }
            .site-preloader__fade {
                transition: opacity .3s;
                opacity: 0;
            }
        </style>
        <img width="300px" src="../../../../assets/Home-Connect/loader.gif" alt="loader">
    </div>